var templateTypes = /*#__PURE__*/function (templateTypes) {
  templateTypes["default"] = "DEFAULT";
  templateTypes["vertical"] = "VERTICAL";
  templateTypes["enterprise"] = "ENTERPRISE";
  return templateTypes;
}({});
var ShareOptionTypes = /*#__PURE__*/function (ShareOptionTypes) {
  ShareOptionTypes["Facebook"] = "FACEBOOK";
  ShareOptionTypes["Twitter"] = "TWITTER";
  ShareOptionTypes["LinkedIn"] = "LINKEDIN";
  ShareOptionTypes["YouTube"] = "YOUTUBE";
  ShareOptionTypes["Email"] = "EMAIL";
  ShareOptionTypes["Print"] = "PRINT";
  ShareOptionTypes["Instagram"] = "INSTAGRAM";
  return ShareOptionTypes;
}({});

export { ShareOptionTypes, templateTypes };
//# sourceMappingURL=types.esm.js.map
